import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { Converter } from '@app/shared/utils/converter';
import { DateFormatStore } from '@app/session/date-format-store';
import { TimeZoneService } from '@app/services/time-zone.service';

@Pipe({
  name: 'roomDateFormat',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class RoomDateFormatPipe implements PipeTransform {
  private timeZoneService = inject(TimeZoneService);

  transform(value: Date | string, options?: { includeTimePart?: boolean; applyTimeZone?: boolean }): string {
    if (!value) return '';

    const { includeTimePart, applyTimeZone } = options || {};

    if (typeof value === 'string') {
      value = this.parseStringValue(value);
    }

    if (applyTimeZone) {
      value = this.timeZoneService.convertDomainDateToRoomDate(value);
    }

    const dateFormat = DateFormatStore.dateFormat;
    const timeFormat = Converter.DateAndTime.MAIN_TIME_FORMAT;

    const formattedDate = moment(value).format(dateFormat);
    const formattedTime = moment(value).format(timeFormat);

    return includeTimePart ? `${formattedDate} ${formattedTime}` : formattedDate;
  }

  private parseStringValue(value: string): Date {
    let parsedValue: Date;

    parsedValue = Converter.DateAndTime.fromCSharpString(value);
    if (!parsedValue) {
      parsedValue = Converter.DateAndTime.parseStringToJSDate(value);
    }

    return parsedValue;
  }
}
